'use client'

import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon } from 'lucide-react'
import { cn } from '../../utils'

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'border-light/30 data-[state=checked]:bg-light/10 data-[state=checked]:text-foreground dark:data-[state=checked]:bg-primary aria-invalid:border-danger shadow-xs data-[state=checked]:border-light/30 peer size-4 shrink-0 rounded-[2px] border-[1px] bg-transparent outline-none transition-shadow disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon stroke={'rgb(255 255 255 / 0.6)'} strokeWidth={2.5} className="size-2" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
